module.exports = __webpack_public_path__ + "media/bootstrap-icons/sunrise-5bac81b9.svg";